export const worklogTypes = [{
  id: 10001,
  type: 'Manual',
  name: 'Manual',
  description: '',
  color: '#d89cdf',
}, {
  id: 10002,
  type: 'Automatic',
  name: 'Automatic',
  description: '',
  color: '#6fc1fb',
}, {
  id: 10003,
  type: 'In-Progress',
  name: 'In-Progress',
  description: '',
  color: '#74d376',
}, {
  id: 10004,
  type: 'Mixed',
  name: 'Mixed',
  description: '',
  color: '#fead5c',
}];

export const issueFields = [
  'versions',
  'timeestimate',
  'fixVersions',
  'timeestimate',
  'fixVersions',
  'project',

  'worklog',
  'summary',
  'priority',
  'issuetype',
  'description',
];
